function ShopsOfficeIcon() {
  return(
    <svg width="60" height="60" viewBox="0 0 60 60" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g clipPath="url(#clip0_1297_8958)">
        <path d="M30 60C46.5685 60 60 46.5685 60 30C60 13.4315 46.5685 0 30 0C13.4315 0 0 13.4315 0 30C0 46.5685 13.4315 60 30 60Z" fill="#EFF8FA"/>
        <path d="M46.6361 34.1068H35.2135C33.9501 34.1068 32.9258 35.1345 32.9258 36.4022V42.1047C32.9258 43.3725 33.9501 44.4002 35.2135 44.4002H46.6361C47.8996 44.4002 48.9238 43.3725 48.9238 42.1047V36.4022C48.9238 35.1345 47.8996 34.1068 46.6361 34.1068Z" stroke="#323232" strokeWidth="1.4" strokeLinecap="round" strokeLinejoin="round"/>
        <path d="M36.4092 40.9051V37.6019H45.4405V40.9051L44.5876 40.5932C42.2201 39.7294 39.6216 39.7294 37.2542 40.5932L36.4012 40.9051H36.4092Z" fill="#0C8188"/>
        <path d="M37.7324 34.1068V31.8194C37.7324 30.9556 38.4259 30.2598 39.2868 30.2598H42.5549C43.4158 30.2598 44.1093 30.9556 44.1093 31.8194V34.1068" stroke="#323232" strokeWidth="1.4" strokeLinecap="round" strokeLinejoin="round"/>
        <path d="M35.0385 33.9948V22.3818H21.3521V42.6086H32.6472" stroke="#323232" strokeWidth="1.4" strokeMiterlimit="10" strokeLinecap="round"/>
        <path d="M33.1327 42.6086H14.1057V23.6375V19.7025H42.2835V23.6375V30.2678" stroke="#323232" strokeWidth="1.4" strokeLinecap="round" strokeLinejoin="round"/>
        <path d="M28.071 22.7417V42.6086" stroke="#323232" strokeWidth="1.4" strokeMiterlimit="10"/>
        <path d="M26.1496 30.2678H24.5554V36.6662H26.1496V30.2678Z" fill="#0C8188"/>
        <path d="M31.3791 30.2676H29.7849V36.6659H31.3791V30.2676Z" fill="#FFC524"/>
        <path d="M43.9894 19.7025H12.3999L13.197 14.3999H43.1923L43.9894 19.7025Z" stroke="#323232" strokeWidth="1.4" strokeMiterlimit="10" strokeLinecap="round"/>
      </g>
      <defs>
        <clipPath id="clip0_1297_8958">
          <rect width="60" height="60" fill="white"/>
        </clipPath>
      </defs>
    </svg>
  );
}

export default ShopsOfficeIcon;

